import { render } from "./EmailDelayNoticeEditPageHeader.vue?vue&type=template&id=523c8f78"
import script from "./EmailDelayNoticeEditPageHeader.vue?vue&type=script&lang=js"
export * from "./EmailDelayNoticeEditPageHeader.vue?vue&type=script&lang=js"

import exportComponent from "/Users/abiinteriors/Documents/WorkSpace/abi-content-manager/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__